module.exports = __webpack_public_path__ + "img/icon_team_white.63663120.svg";